import { DocumentationLegacyPageAsset, } from "../SDKDocumentationLegacyPageAsset";
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
export class DocumentationLegacyPageBlockGuideline extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b, _c, _d;
        super(model, children);
        this.guideline = {
            asset: model.guideline.asset
                ? new DocumentationLegacyPageAsset(model.guideline.asset)
                : null,
            type: (_a = model.guideline.type) !== null && _a !== void 0 ? _a : "do",
            imageAlt: (_b = model.guideline.imageAlt) !== null && _b !== void 0 ? _b : null,
            imageCaption: (_c = model.guideline.imageCaption) !== null && _c !== void 0 ? _c : null,
            imageAlignment: (_d = model.guideline.imageAlignment) !== null && _d !== void 0 ? _d : null,
        };
    }
}
